/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getMeal = /* GraphQL */ `
  query GetMeal($id: ID!) {
    getMeal(id: $id) {
      id
      date
      timing
      protein
      fat
      carbs
      calories
      salt
      iron
      vitaminA
      vitaminB1
      vitaminB2
      vitaminC
      vitaminD
      comment
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listMeals = /* GraphQL */ `
  query ListMeals(
    $filter: ModelMealFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMeals(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        date
        timing
        protein
        fat
        carbs
        calories
        salt
        iron
        vitaminA
        vitaminB1
        vitaminB2
        vitaminC
        vitaminD
        comment
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserCharacter = /* GraphQL */ `
  query GetUserCharacter($id: ID!) {
    getUserCharacter(id: $id) {
      id
      characterId
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listUserCharacters = /* GraphQL */ `
  query ListUserCharacters(
    $filter: ModelUserCharacterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserCharacters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        characterId
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRecipe = /* GraphQL */ `
  query GetRecipe($id: ID!) {
    getRecipe(id: $id) {
      id
      title
      description
      isPublic
      imageUrl
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRecipes = /* GraphQL */ `
  query ListRecipes(
    $filter: ModelRecipeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecipes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        isPublic
        imageUrl
        owner
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getIngredient = /* GraphQL */ `
  query GetIngredient($id: ID!) {
    getIngredient(id: $id) {
      id
      recipeId
      name
      amount
      unit
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listIngredients = /* GraphQL */ `
  query ListIngredients(
    $filter: ModelIngredientFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIngredients(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        recipeId
        name
        amount
        unit
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStep = /* GraphQL */ `
  query GetStep($id: ID!) {
    getStep(id: $id) {
      id
      recipeId
      order
      description
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listSteps = /* GraphQL */ `
  query ListSteps(
    $filter: ModelStepFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSteps(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        recipeId
        order
        description
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFoodMaster = /* GraphQL */ `
  query GetFoodMaster($id: ID!) {
    getFoodMaster(id: $id) {
      id
      name
      yomi
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFoodMasters = /* GraphQL */ `
  query ListFoodMasters(
    $filter: ModelFoodMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFoodMasters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        yomi
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
